import { Box, Divider, Grid, Typography } from "@mui/material";
import { ReactElement } from "react";
import { CardsStatics } from "src/Pages/components/CardsStatics";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { GroupIcon } from "src/Pages/components/Icons/Icons";
import { ChipCore } from "src/Pages/components/ChipCore/ChipCore";
import { objColorsChipsFunctionProducer } from "src/shared/ColorObj/ColorsChipsFunctionProducer";

interface ICardsMetricsProducer {
  metrics: {
    total: number;
    corretor: number;
    supervisor: number;
    gerente: number;
  };
}

interface ICardMetricFunctionItem {
  chipColor: string;
  chipIcon: ReactElement;
  chipLabel: string;
  value: number;
  valueLabel: string;
  withLeftPadding?: boolean;
}

const CardMetricFunctionItem = ({
  chipColor,
  chipIcon,
  chipLabel,
  value,
  valueLabel,
  withLeftPadding,
}: ICardMetricFunctionItem) => {
  return (
    <Box
      sx={{
        flex: 1,
        paddingLeft: withLeftPadding ? "12px" : undefined,
        minHeight: "92px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <ChipCore
        colorCore={chipColor}
        icon={chipIcon}
        label={chipLabel}
        sxStyle={{ marginBottom: "6px", maxWidth: "120px" }}
      />

      <Box sx={{ display: "flex", gap: 1 }}>
        <Typography sx={{ fontSize: "16px", fontWeight: 700, marginTop: "10px" }}>
          {value}
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            marginTop: "10px",
            color: "text.secondary",
          }}
        >
          {valueLabel}
        </Typography>
      </Box>
    </Box>
  );
};

export const CardsMetricsProducer = ({ metrics }: ICardsMetricsProducer) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <CardsStatics
          data={{
            name: "Total de produtores",
            value1: {
              value: metrics.total.toString(),
              valueSub: "registros",
            },
            icon: <GroupIcon color="primary" sx={{ fontSize: "22px" }} />,
          }}
        />
      </Grid>

      <Grid item xs={12} md={9}>
        <CardCore
          sxStyle={{
            margin: 0,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "stretch",
            }}
          >
            <CardMetricFunctionItem
              chipColor={objColorsChipsFunctionProducer.CORRETOR.color}
              chipIcon={objColorsChipsFunctionProducer.CORRETOR.icon}
              chipLabel={objColorsChipsFunctionProducer.CORRETOR.label}
              value={metrics.corretor}
              valueLabel="Corretores"
            />

            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", sm: "block" } }} />

            <CardMetricFunctionItem
              chipColor={objColorsChipsFunctionProducer.SUPERVISOR.color}
              chipIcon={objColorsChipsFunctionProducer.SUPERVISOR.icon}
              chipLabel={objColorsChipsFunctionProducer.SUPERVISOR.label}
              value={metrics.supervisor}
              valueLabel="Supervisores"
              withLeftPadding
            />

            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", sm: "block" } }} />

            <CardMetricFunctionItem
              chipColor={objColorsChipsFunctionProducer.GERENTE.color}
              chipIcon={objColorsChipsFunctionProducer.GERENTE.icon}
              chipLabel={objColorsChipsFunctionProducer.GERENTE.label}
              value={metrics.gerente}
              valueLabel="Gerentes"
              withLeftPadding
            />
          </Box>
        </CardCore>
      </Grid>
    </Grid >
  );
};
